<div class="">
    <div class="card-header d-flex align-items-center justify-content-between" style="padding: 0 24px ">
        <p class="card-title mb-0" >Marques, catégories et unités</p>
        <app-add-menu></app-add-menu>
    </div>
    <div class="card-body p-0">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'catégorie'" (click)="setActiveTab('catégorie')" href="javascript:void(0)">Catégorie</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'unité'" (click)="setActiveTab('unité')" href="javascript:void(0)">Unité</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [class.active]="activeTab === 'marque'" (click)="setActiveTab('marque')" href="javascript:void(0)">Marque</a>
            </li>
        </ul>
        <div class="tab-content">
            <div class="tab-pane" [class.active]="activeTab === 'catégorie'">
                <app-parametre-categories></app-parametre-categories>
            </div>
            <div class="tab-pane" [class.active]="activeTab === 'unité'">
                <app-parametre-unite></app-parametre-unite>
            </div>
            <div class="tab-pane" [class.active]="activeTab === 'marque'">
                <app-parametre-marque></app-parametre-marque>
            </div>
        </div>
    </div>
</div>
